/**
 * Use this file to add variables/constants that contain configuration for the project.
 * Only add variables here if they need to be consumed by both, the app and build tools.
 */

type RoutePathType = (typeof ROUTE_PATHS)[keyof typeof ROUTE_PATHS];

const ROUTES = {
  // Landing/home route.
  DASHBOARD: 'dashboard',

  // Authentication routes.
  SIGN_IN: 'sign-in',
  SIGN_IN_OTP: 'sign-in_otp',
  SIGN_IN_EMAIL: 'sign-in_email',
  SIGN_IN_DETAILS: 'sign-in_details',
  SIGN_IN_ERROR: 'sign-in_error',

  // Private claims routes.
  CLAIMS: 'claims',
  NEW_CLAIM: 'new-claim',
  RESUME_CLAIM: 'resume-claim',

  // Other private routes.
  IMPORTANT_INFO: 'important-information',
  POLICIES: 'policies',
  SUPPORT: 'support',

  // Other public routes.
  NOTFOUND: 'not-found',
  VERSION: 'version',
  ERROR: 'error',
};

const ROUTE_PATHS = {
  // Landing/home route.
  [ROUTES.DASHBOARD]: `/`,

  // Authentication routes.
  [ROUTES.SIGN_IN]: `/sign-in`,
  [ROUTES.SIGN_IN_OTP]: `/sign-in/otp`,
  [ROUTES.SIGN_IN_EMAIL]: `/sign-in/email`,
  [ROUTES.SIGN_IN_DETAILS]: `/sign-in/details`,
  [ROUTES.SIGN_IN_ERROR]: `/sign-in/error`,

  // Private claims routes.
  [ROUTES.CLAIMS]: `/claims`,
  [ROUTES.NEW_CLAIM]: '/claims/make-a-claim/:policyNo',
  [ROUTES.RESUME_CLAIM]: '/claims/resume-claim/:claimNo',

  // Other private routes.
  [ROUTES.IMPORTANT_INFO]: `/important-information`,
  [ROUTES.POLICIES]: `/policies`,
  [ROUTES.SUPPORT]: `/support`,

  // Other public routes.
  [ROUTES.NOTFOUND]: `/not-found`,
  [ROUTES.VERSION]: `/version`,
  [ROUTES.ERROR]: `/error`,
};

const ROUTE_PATH_VALUES = Object.values(ROUTE_PATHS);

function getChildPathForRouteObject(childRoutePath: RoutePathType, parentRoutePath: RoutePathType) {
  return childRoutePath.replace(`${parentRoutePath}/`, '');
}

export { getChildPathForRouteObject, ROUTE_PATH_VALUES, ROUTE_PATHS, ROUTES };
export type { RoutePathType };
